(ns teamoesterreich.admin-mode.warnings.warning-region
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [goog.json :as json]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.admin-mode.data.warning :as d-warning]
            [teamoesterreich.admin-mode.map.map-polygon-picker :as map-polygon-picker]


            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]

            [clojure.string :as string]))

(defn un-serialize-path [in]
  (json/parse in))


(defn radio [name !radio]
  [mui/form-control-label {:label   name :value "dst" :placement "start"
                           :control (r/as-element [mui/radio {:checked  @!radio
                                                              :onChange (fn [val])
                                                              }])}]

  )



(defn region-selector [!warningCap editable?]
  (let [!st (r/atom {:region-type nil
                     :path        #js []
                     :new-region  nil
                     :regions     (json/parse (:warningCap-regions @!warningCap))})
        !edit-mode (r/cursor !st [:edit-mode])
        !region-type (r/cursor !st [:region-type])
        !regions (r/cursor !st [:regions])
        !new-region (r/cursor !st [:new-region])
        !path (r/cursor !st [:path])]
    (fn []
      (let [

            reset-fn (fn [] (reset! !st {:region-type nil :path #js [] :regions nil}))

            initial-path (when (and (:crowdtaskerEvent-locationPolygonJsonString @!warningCap) (not= (:crowdtaskerEvent-locationPolygonJsonString @!warningCap) ""))
                           (un-serialize-path (:crowdtaskerEvent-locationPolygonJsonString @!warningCap)))

            g-regions (:crowdtaskerEvent-regions @!warningCap)

            g-type (cond
                     (:warningCap-regions @!warningCap) :regions
                     (:warningCap-polygon @!warningCap) :polygon
                     :else :none
                     )
            changed? (or (and @!region-type (not= g-type @!region-type))
                         (and @!regions (not= g-regions @!regions)))
            ]
        [mui/paper
         {:style {:textAlign "left" :padding "10px"}}
         [:h3 (str @!region-type)]
         [mui/form-control {:component "fieldset"}
          [mui/radio-group {:row      true
                            :style    {:float "left" :padding "10px" :backgroundColor (if changed? "#ffd6d2" "#ffffff")}
                            :value    (or @!region-type g-type)
                            :onChange (fn [e] (reset! !region-type (keyword (h/event-value e))))
                            }
           [mui/form-control-label
            {:value   :none
             :style   {:width "300px"}
             :control (r/as-element [mui/radio {:color "primary" :disabled (not @!edit-mode)}])
             :label   (str "Keine Region")
             }
            ]
           [mui/form-control-label
            {:value   :regions
             :style   {:width "300px"}
             :control (r/as-element [mui/radio {:color "primary" :disabled (not @!edit-mode)}])
             :label   (str "Regionen")
             }
            ]
           [mui/form-control-label
            {:value   :polygon
             :style   {:width "300px"}
             :control (r/as-element [mui/radio {:color "primary" :disabled (not @!edit-mode)}])
             :label   (str "Polygon")
             }
            ]

           ]]

         [:br]
         (case (or @!region-type g-type)
           :none [:div {:style {:padding "7px 0 7px 0"}}
                  [mui/chip {:label "Keine Regions-Eingrenzung"}]
                  [:br] [:br]
                  (when (and editable? (not @!edit-mode))
                    [mui/button {
                                 :variant   "contained"
                                 :startIcon (r/as-element [edit])
                                 :onClick   #(reset! !edit-mode true)
                                 } "Bearbeiten"])

                  (when (and (not editable?) (not @!edit-mode) (d-rights/is-superuser?))
                    [mui/button {
                                 :variant   "outlined"
                                 :style     {:color "orange" :margin "5px 40px 5px 40px"}
                                 :startIcon (r/as-element [edit])
                                 :onClick   #(reset! !edit-mode true)
                                 } "Bearbeiten (superuser)"])

                  (when @!edit-mode
                    [mui/button {:variant   "contained"
                                 :startIcon (r/as-element [keyboard-arrow-left])
                                 :onClick   reset-fn
                                 } "Abbrechen"])
                  (when @!edit-mode
                    [mui/button {:variant   "contained"
                                 :style     {:marginLeft "20px"}
                                 :disabled  (if changed? false true)
                                 :color     "primary"
                                 :onClick   (fn [])
                                 :startIcon (r/as-element [save])}
                     "Speichern"])
                  ]

           :polygon [:div {:style {:padding "7px 0 7px 0"}}
                     [map-polygon-picker/pick-polygon-gmap-component !st initial-path @!edit-mode]
                     ;[map-polygon-picker/pick-polygon-test]
                     [:br] [:br]

                     (when (and editable? (not @!edit-mode))
                       [mui/button {
                                    :variant   "contained"
                                    :startIcon (r/as-element [edit])
                                    :onClick   #(reset! !edit-mode true)
                                    } "Bearbeiten"])

                     (when (and (not editable?) (not @!edit-mode) (d-rights/is-superuser?))
                       [mui/button {
                                    :variant   "outlined"
                                    :style     {:color "orange" :margin "5px 40px 5px 40px"}
                                    :startIcon (r/as-element [edit])
                                    :onClick   #(reset! !edit-mode true)
                                    } "Bearbeiten (superuser)"])

                     (when @!edit-mode
                       [mui/button {:variant   "contained"
                                    :startIcon (r/as-element [keyboard-arrow-left])
                                    :onClick   reset-fn
                                    } "Abbrechen"])
                     (when @!edit-mode
                       [mui/button {:variant   "contained"
                                    :startIcon (r/as-element [edit])
                                    :style     {:marginLeft "20px"}
                                    :onClick   #(swap! !st assoc :pickMode true :path #js [])
                                    } "Polygon beginnen"])
                     (when @!edit-mode
                       [mui/button {:variant   "contained"
                                    :style     {:marginLeft "20px"}
                                    :color     "primary"
                                    :onClick   (fn []
                                                 (when (> (count (:path @!st)) 2)
                                                   ))
                                    :startIcon (r/as-element [save])}
                        "Speichern"])
                     ]


           :regions [:div {:style {:padding "7px 0 7px 0"}}
                     [:br]

                     [:div

                      (for [region (sort @!regions)]
                        ^{:key (str "REGION-" region)}
                        [mui/chip {:label    (str "" region)
                                   :onDelete (fn [])}
                         ;[delete-forever]
                         ])

                      ]


                     (when @!edit-mode
                       [:div

                        [:h3 "Region hinzufügen"]

                        [mui/select {:style    {:width "300px" :backgroundColor (if @!new-region "#ffd6d2" "#ffffff")}
                                     :value    @!new-region
                                     :disabled (not @!edit-mode)
                                     :onChange (fn [e] (reset! !new-region (h/event-value e)))
                                     }
                         (for [[k v] (sort-by first (txt/txt :fake :districts))]
                           ^{:key (str "DISTRICT-" k)}
                           [mui/menu-item {:key (str "" k) :value k} v])
                         ]
                        (when @!new-region
                          [mui/button {:style {:margin "5px 40px 5px 20px" :width "200px"}
                                       :startIcon (r/as-element [add]) :variant "outlined" :color "primary"
                                       :onClick   #(reset! !new-region nil)
                                       } "Hinzufügen"])
                        ])
                     [:br]
                     [:br]
                     (when (and editable? (not @!edit-mode))
                       [mui/button {
                                    :variant   "contained"
                                    :startIcon (r/as-element [edit])
                                    :onClick   #(reset! !edit-mode true)
                                    } "Bearbeiten"])

                     (when (and (not editable?) (not @!edit-mode) (d-rights/is-superuser?))
                       [mui/button {
                                    :variant   "outlined"
                                    :style     {:color "orange" :margin "5px 40px 5px 40px"}
                                    :startIcon (r/as-element [edit])
                                    :onClick   #(reset! !edit-mode true)
                                    } "Bearbeiten (superuser)"])

                     (when @!edit-mode
                       [mui/button {:variant   "contained"
                                    :startIcon (r/as-element [keyboard-arrow-left])
                                    :onClick   reset-fn
                                    } "Fertig"])
                     ]

           ""
           )
         ]

        ))))












































